import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const ProfileNavSolidIcon = (props) => (
  <SVGUniqueID>
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.89401 16.0948C3.98222 13.88 6.83804 12.4998 10.0003 12.4998C13.1627 12.4998 16.0185 13.88 18.1067 16.0948C18.3348 16.3368 18.3973 16.6913 18.2655 16.9967C18.1337 17.3021 17.8329 17.4998 17.5003 17.4998H2.50034C2.16775 17.4998 1.867 17.3021 1.73522 16.9967C1.60343 16.6913 1.66585 16.3368 1.89401 16.0948Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.41701 6.24984C5.41701 3.71853 7.46904 1.6665 10.0003 1.6665C12.5316 1.6665 14.5837 3.71853 14.5837 6.24984C14.5837 8.78114 12.5316 10.8332 10.0003 10.8332C7.46904 10.8332 5.41701 8.78114 5.41701 6.24984Z"
        fill="currentColor"
      />
    </svg>
  </SVGUniqueID>
);
export { ProfileNavSolidIcon };
